import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import axios from "axios";
import API_URL from "../config";
import PhoneInput from "../components/PhoneInput";
export default function Checkout() {
  const { cart } = useContext(CartContext);

  const [form, setForm] = useState({
    name: "", email: "", phone: "", address: "", city: "", notes: ""
  });
  const [paymentMethod, setPaymentMethod] = useState("jazzcash");
  const [loading, setLoading]             = useState(false);
  const [error, setError]                 = useState("");

  const total      = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const shipping   = total >= 2000 ? 0 : 150;
  const grandTotal = total + shipping;

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    if (cart.length === 0) return;
    if (!form.name || !form.phone || !form.address) {
      setError("Please fill in all required fields.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const orderRes = await axios.post(`${API_URL}/api/orders`, {
        customerName:  form.name,
        email:         form.email,
        phone:         form.phone,
        address:       form.address,
        city:          form.city,
        notes:         form.notes,
        items:         cart.map(i => ({
          productId:  i._id,
          name:       i.name,
          price:      i.price,
          quantity:   i.quantity,
          size:       i.selectedSize  || null,
          color:      i.selectedColor || null,
        })),
        subtotal:      total,
        shipping:      shipping,
        total:         grandTotal,
        paymentMethod,
        paymentStatus: "pending",
        status:        "pending"
      });

      const orderId = orderRes.data._id;

      const payRes = await axios.post(`${API_URL}/api/payment/${paymentMethod}`, {
        orderId,
        amount: grandTotal,
        phone:  form.phone
      });

      const { url, formData } = payRes.data;

      const formEl = document.createElement("form");
      formEl.method = "POST";
      formEl.action = url;

      Object.entries(formData).forEach(([key, val]) => {
        const input = document.createElement("input");
        input.type  = "hidden";
        input.name  = key;
        input.value = val;
        formEl.appendChild(input);
      });

      document.body.appendChild(formEl);
      formEl.submit();

    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
      setLoading(false);
    }
  };

  if (cart.length === 0) {
    return (
      <>
        <style>{chStyles}</style>
        <div className="ch-root">
          <div className="ch-empty">
            <span className="ch-empty-icon">🛍</span>
            <span className="ch-empty-title">Your cart is empty</span>
            <Link to="/products" className="ch-empty-btn">Browse Products</Link>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <style>{chStyles}</style>
      <div className="ch-root">

        <div className="ch-header">
          <span className="ch-eyebrow">Almost there</span>
          <span className="ch-title">Checkout</span>
        </div>

        <div className="ch-layout">

          <form onSubmit={handleSubmit} className="ch-form">

            <div className="ch-section">
              <span className="ch-section-title">Contact Information</span>
              <div className="ch-row-2">
                <div className="ch-field">
                  <label className="ch-label">Full Name *</label>
                  <input name="name" value={form.name} onChange={handleChange}
                    className="ch-input" placeholder="Sara Khan" required />
                </div>
                <div className="ch-field">
                  <label className="ch-label">Phone Number *</label>
                  <PhoneInput name="phone" value={form.phone} onChange={handleChange}
                    className="ch-input" placeholder="03XX XXXXXXX" required />
                </div>
              </div>
              <div className="ch-field">
                <label className="ch-label">Email (optional)</label>
                <input name="email" type="email" value={form.email} onChange={handleChange}
                  className="ch-input" placeholder="sara@email.com" />
              </div>
            </div>

            <div className="ch-section">
              <span className="ch-section-title">Delivery Address</span>
              <div className="ch-field">
                <label className="ch-label">Street Address *</label>
                <input name="address" value={form.address} onChange={handleChange}
                  className="ch-input" placeholder="House #, Street, Area" required />
              </div>
              <div className="ch-row-2">
                <div className="ch-field">
                  <label className="ch-label">City *</label>
                  <input name="city" value={form.city} onChange={handleChange}
                    className="ch-input" placeholder="Lahore, Karachi…" required />
                </div>
                <div className="ch-field">
                  <label className="ch-label">Order Notes (optional)</label>
                  <input name="notes" value={form.notes} onChange={handleChange}
                    className="ch-input" placeholder="e.g. call before delivery" />
                </div>
              </div>
            </div>

            <div className="ch-section">
              <span className="ch-section-title">Payment Method</span>
              <div className="ch-payment-options">
                <label className={`ch-pay-option ${paymentMethod === "jazzcash" ? "active" : ""}`}>
                  <input type="radio" name="paymentMethod" value="jazzcash"
                    checked={paymentMethod === "jazzcash"}
                    onChange={() => setPaymentMethod("jazzcash")} />
                  <div className="ch-pay-logo jc-logo"><span className="ch-pay-letter">JC</span></div>
                  <div className="ch-pay-info">
                    <span className="ch-pay-name">JazzCash</span>
                    <span className="ch-pay-sub">Mobile wallet · instant</span>
                  </div>
                  <div className={`ch-pay-check ${paymentMethod === "jazzcash" ? "on" : ""}`} />
                </label>
                <label className={`ch-pay-option ${paymentMethod === "easypaisa" ? "active" : ""}`}>
                  <input type="radio" name="paymentMethod" value="easypaisa"
                    checked={paymentMethod === "easypaisa"}
                    onChange={() => setPaymentMethod("easypaisa")} />
                  <div className="ch-pay-logo ep-logo"><span className="ch-pay-letter">EP</span></div>
                  <div className="ch-pay-info">
                    <span className="ch-pay-name">Easypaisa</span>
                    <span className="ch-pay-sub">Mobile wallet · instant</span>
                  </div>
                  <div className={`ch-pay-check ${paymentMethod === "easypaisa" ? "on" : ""}`} />
                </label>
              </div>
              <div className="ch-pay-note">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}>
                  <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                You will be redirected to {paymentMethod === "jazzcash" ? "JazzCash" : "Easypaisa"} to complete your payment securely.
              </div>
            </div>

            {error && <p className="ch-error">{error}</p>}

            <button type="submit" disabled={loading} className="ch-submit">
              {loading
                ? "Processing…"
                : `Pay ${grandTotal.toLocaleString()} PKR via ${paymentMethod === "jazzcash" ? "JazzCash" : "Easypaisa"}`}
            </button>

          </form>

          <div className="ch-summary">
            <span className="ch-section-title">Order Summary</span>
            <div className="ch-items">
              {cart.map(item => (
                <div key={item._cartKey} className="ch-item">
                  <div className="ch-item-img-wrap">
                    <img src={item.image} alt={item.name} className="ch-item-img" />
                    <span className="ch-item-qty">{item.quantity}</span>
                  </div>
                  <div className="ch-item-info">
                    <span className="ch-item-name">{item.name}</span>
                    {item.selectedSize  && <span className="ch-item-var">Size: {item.selectedSize}</span>}
                    {item.selectedColor && <span className="ch-item-var">Color: {item.selectedColor}</span>}
                  </div>
                  <span className="ch-item-price">{(item.price * item.quantity).toLocaleString()} PKR</span>
                </div>
              ))}
            </div>
            <div className="ch-totals">
              <div className="ch-total-row"><span>Subtotal</span><span>{total.toLocaleString()} PKR</span></div>
              <div className="ch-total-row"><span>Shipping</span><span>{shipping === 0 ? "Free" : `${shipping} PKR`}</span></div>
              {shipping === 0 && <div className="ch-free-ship">🎉 Free shipping on orders above 2,000 PKR</div>}
              <div className="ch-divider" />
              <div className="ch-total-row grand"><span>Total</span><span>{grandTotal.toLocaleString()} PKR</span></div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

const chStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,400&family=DM+Sans:wght@300;400;500&display=swap');
  .ch-root*,.ch-root *::before,.ch-root *::after{box-sizing:border-box;margin:0;padding:0}
  .ch-root{font-family:'DM Sans',sans-serif;background:#fdf9f6;min-height:80vh;padding:40px;max-width:1100px;margin:0 auto}
  @media(max-width:768px){.ch-root{padding:24px 16px 60px}}
  .ch-header{margin-bottom:36px}
  .ch-eyebrow{font-size:10px;font-weight:500;letter-spacing:.26em;text-transform:uppercase;color:#c87090;margin-bottom:8px;display:block}
  .ch-title{font-family:'Cormorant Garamond',serif;font-size:clamp(28px,5vw,42px);font-weight:300;color:#1a1410;display:block;letter-spacing:-.01em}
  .ch-layout{display:grid;grid-template-columns:1fr 380px;gap:40px;align-items:start}
  @media(max-width:900px){.ch-layout{grid-template-columns:1fr;gap:32px}}
  .ch-section{background:#fff;border:1px solid #ede8e2;padding:24px;margin-bottom:16px}
  .ch-section-title{font-family:'Cormorant Garamond',serif;font-size:20px;font-weight:400;color:#1a1410;display:block;margin-bottom:18px}
  .ch-row-2{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:14px}
  @media(max-width:480px){.ch-row-2{grid-template-columns:1fr}}
  .ch-field{display:flex;flex-direction:column;gap:6px;margin-bottom:14px}
  .ch-field:last-child{margin-bottom:0}
  .ch-label{font-size:10.5px;font-weight:500;letter-spacing:.16em;text-transform:uppercase;color:#7a6e68}
  .ch-input{border:1.5px solid #ddd8d2;background:#fdf9f6;padding:10px 12px;font-size:13.5px;font-family:'DM Sans',sans-serif;color:#1a1410;outline:none;transition:border-color .18s;width:100%}
  .ch-input:focus{border-color:#c87090;background:#fff}
  .ch-payment-options{display:flex;flex-direction:column;gap:10px;margin-bottom:14px}
  .ch-pay-option{display:flex;align-items:center;gap:14px;border:1.5px solid #ddd8d2;padding:14px 16px;cursor:pointer;transition:all .18s}
  .ch-pay-option input{display:none}
  .ch-pay-option.active{border-color:#c87090;background:#fff8fa}
  .ch-pay-logo{width:42px;height:42px;border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
  .jc-logo{background:#cc0000}.ep-logo{background:#00a651}
  .ch-pay-letter{font-size:13px;font-weight:700;color:white;letter-spacing:.04em}
  .ch-pay-info{flex:1}
  .ch-pay-name{font-size:14px;font-weight:500;color:#1a1410;display:block}
  .ch-pay-sub{font-size:11.5px;font-weight:300;color:#a09890;display:block;margin-top:2px}
  .ch-pay-check{width:18px;height:18px;border-radius:50%;border:1.5px solid #ddd8d2;flex-shrink:0;transition:all .18s;display:flex;align-items:center;justify-content:center}
  .ch-pay-check.on{border-color:#c87090;background:#c87090}
  .ch-pay-check.on::after{content:'';width:6px;height:6px;border-radius:50%;background:white}
  .ch-pay-note{display:flex;align-items:flex-start;gap:8px;font-size:12px;color:#a09890;line-height:1.5;background:#f7f4f1;padding:11px 13px}
  .ch-error{font-size:13px;color:#c87090;font-style:italic;margin-bottom:12px}
  .ch-submit{width:100%;padding:15px;background:#1a1410;color:#fdf9f6;border:none;font-size:12px;font-weight:500;font-family:'DM Sans',sans-serif;letter-spacing:.16em;text-transform:uppercase;cursor:pointer;transition:background .22s}
  .ch-submit:hover{background:#c87090}
  .ch-submit:disabled{opacity:.55;cursor:not-allowed}
  .ch-summary{background:#fff;border:1px solid #ede8e2;padding:24px;position:sticky;top:80px}
  .ch-items{display:flex;flex-direction:column;gap:14px;margin-bottom:20px;max-height:360px;overflow-y:auto}
  .ch-item{display:flex;align-items:center;gap:12px}
  .ch-item-img-wrap{position:relative;flex-shrink:0}
  .ch-item-img{width:56px;height:70px;object-fit:cover;background:#f4efe9;display:block}
  .ch-item-qty{position:absolute;top:-6px;right:-6px;width:18px;height:18px;background:#c87090;color:white;border-radius:50%;font-size:10px;font-weight:700;display:flex;align-items:center;justify-content:center}
  .ch-item-info{flex:1;min-width:0}
  .ch-item-name{font-size:13px;font-weight:500;color:#1a1410;display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  .ch-item-var{font-size:11px;color:#a09890;display:block}
  .ch-item-price{font-size:13px;font-weight:500;color:#1a1410;white-space:nowrap;flex-shrink:0}
  .ch-totals{border-top:1px solid #ede8e2;padding-top:16px}
  .ch-total-row{display:flex;justify-content:space-between;align-items:center;font-size:13.5px;color:#5a524c;margin-bottom:8px}
  .ch-free-ship{font-size:11.5px;color:#c87090;background:#fff5f8;padding:7px 10px;margin-bottom:8px}
  .ch-divider{height:1px;background:#ede8e2;margin:12px 0}
  .ch-total-row.grand{font-size:16px;font-weight:500;color:#1a1410}
  .ch-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:50vh;gap:14px;text-align:center}
  .ch-empty-icon{font-size:48px}
  .ch-empty-title{font-family:'Cormorant Garamond',serif;font-size:28px;font-weight:300;color:#1a1410;display:block}
  .ch-empty-btn{display:inline-block;background:#1a1410;color:#fdf9f6;font-size:11px;font-weight:500;letter-spacing:.18em;text-transform:uppercase;text-decoration:none;padding:12px 28px;transition:background .2s;margin-top:8px}
  .ch-empty-btn:hover{background:#c87090}
`;